import { render } from "./winemakerPrice.vue?vue&type=template&id=6025834a&ts=true"
import script from "./winemakerPrice.vue?vue&type=script&lang=ts"
export * from "./winemakerPrice.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__